import { Capacitor } from '@capacitor/core';

const SPLASH_FADE_MS = 280;

/**
 * Masque le splash natif Capacitor avec fondu — appelé quand l'overlay React
 * est peint pour une transition sans flash blanc.
 */
export async function hideNativeSplashWithFade(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;

  try {
    const { SplashScreen } = await import('@capacitor/splash-screen');
    await SplashScreen.hide({ fadeOutDuration: SPLASH_FADE_MS });
  } catch {
    /* plugin absent */
  }
}

export const NATIVE_SPLASH_FADE_MS = SPLASH_FADE_MS;
